import React, { useRef } from 'react';
import emailjs from 'emailjs-com';
import { Col, Container, Form, Button } from 'react-bootstrap';

const Contact = () => {

    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_i39b25f', 'template_3e880f8', form.current, 'user_RQJAc5DA62MYxrZJC6z7X')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });
        e.target.reset();
    };

    return (
        <>
            <Container className="my-5">
                <Col md={{ span: 6, offset: 3 }}>
                    <h2>Email me</h2>
                    <Form ref={form} onSubmit={sendEmail}>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Control type="text" placeholder="Your Name" name="from_name" required />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Control type="email" placeholder="Enter Your Email Address" name="from_email" required />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                            <Form.Control as="textarea" rows={3} placeholder="Write your massage" name="message" required />
                        </Form.Group>
                        <Button type="submit">SEND</Button>
                    </Form>
                </Col>
            </Container>
        </>
    );
};

export default Contact;